var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.8vw",
    height: "1.8vw",
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.75,
    width: 34.5,
    height: 34.5,
    rx: 2.75,
    stroke: "#50C878",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2143 14.5714H21.7188M12.6339 10V11.3716M22.1875 10V11.3714M25 14.3714L25 23C25 24.6569 23.6569 26 22 26H13C11.3431 26 10 24.6569 10 23V14.3714C10 12.7146 11.3431 11.3714 13 11.3714H22C23.6569 11.3714 25 12.7146 25 14.3714Z",
    stroke: "#50C878",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.407575b702990dffd1c6c9bbe8fee329.svg";
export { ForwardRef as ReactComponent };